/* @ngInject */

import { default as FEATURES } from '../../../common/feature-enum';
import { default as USER_CLAIMS } from '../../../common/claim-enum';

export default class TenantCtrl {
  constructor(
    $scope,
    $state,
    Utility,
    $timeout,
    $rootScope,
    UserUnitsService,
    TenantDataService,
    NotificationService,
    LocalStorageService,
    AuthorizationService
  ) {
    this.$scope = $scope;
    this.$state = $state;
    this.Utility = Utility;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.noTenantForUnit = false;
    this.UserUnitsService = UserUnitsService;
    this.TenantDataService = TenantDataService;
    this.NotificationService = NotificationService;
    this.LocalStorageService = LocalStorageService;
    this.AuthorizationService = AuthorizationService;

    this.init();
    this.activate();
  }

  init() {
    this.email = '';
    this.lastName = '';
    this.idNumber = '';
    this.tenant = null;
    this.firstName = '';
    this.homeNumber = '';
    this.cellNumber = '';
    this.workNumber = '';
    this.leaseEndDate = '';
    this.selectedUnit = '';
    this.leaseStartDate = '';
    this.userUnits = undefined;
    this.isTenantLoading = false;
    this.isEditingTenant = false;
    this.friendlyUnitNames = null;
    this.isMainPageLoading = false;
    this.friendlyUnitNamesPromise = null;
    this.hasTenantBeenRegistered = false;

    this._handleEvents();
  }

  getUserUnits() {
    let units;
    const userProfile = this.LocalStorageService.retrieve('userProfile');
    const dbRef = this.LocalStorageService.retrieve('selectedBuildingRef');
    const { BuildingProfiles: buildingProfiles } = userProfile;

    if (!!dbRef && !!buildingProfiles && buildingProfiles.length > 0) {
      const selectedBuilding = buildingProfiles.find(building => {
        const { SchemeReference: schemeReference } = building;
        const found = schemeReference.toLowerCase() === dbRef.toLowerCase();
        return found;
      });

      if (!!selectedBuilding) {
        const { BuildingProfileUnit: userUnits } = selectedBuilding;
        units = userUnits;
      }
    }

    return units;
  }

  async handleUnitChange(newSelectedUnit) {
    if (newSelectedUnit && Object.keys(newSelectedUnit).length) {
      await this.getTenantByCardCode();
    }
  }

  activate() {
    this.tenantService = this.TenantDataService;
    this.initialiseScreen();
  }

  async initialiseScreen() {
    this.isMainPageLoading = true;
    try {
      this.friendlyUnitNames = await this.UserUnitsService.getFriendlyUnitNames();
      if (this.friendlyUnitNames.length > 0) {
        
          const defaultUnit = this.friendlyUnitNames[0];
          delete defaultUnit.$$hashKey;
          const json = JSON.stringify(defaultUnit);
          
          this.selectedUnit = `${json}`;
      }

      await this.getTenantByCardCode();
    } catch (err) {
      this.NotificationService.error(
        'COULD NOT RETRIEVE YOUR AVAILABLE UNITS.'
      );
    } finally {
      this.$timeout(() => {
        this.tenant = null;
        this.noTenantForUnit = !!!this.TenantDataService.tenant;
        this.isMainPageLoading = false;
      });
    }
  }

  async getTenantByCardCode() {
    if (this.selectedUnit) {
      this.isTenantLoading = true;
      try {
        let cardCode;
        if (typeof this.selectedUnit === 'string') {
          const objUnit = JSON.parse(this.selectedUnit);
          const { CardCode } = objUnit;
          cardCode = CardCode;
        } else {
          cardCode = this.selectedUnit.CardCode;
        }

        await this.tenantService.getTenantByCardCode(cardCode);
      } catch (error) {
        this.NotificationService.error(error);
      } finally {
        this.$timeout(() => {
          this.tenant = null;
          this.isTenantLoading = false;
          this.noTenantForUnit = !!!this.TenantDataService.tenant;
          this.isEditingTenant = this.noTenantForUnit;

          this._initializeDatePicker();
        });
      }
    }
  }

  async registerTenant() {
    try {
      this.isTenantLoading = true;
      const isUpdating = 'Id' in this.tenant && !!this.tenant.Id;

      let cardCode;
      if (typeof this.selectedUnit === 'string') {
        const mapped = JSON.parse(this.selectedUnit);
        const { CardCode } = mapped;
        cardCode = CardCode;
      } else {
        const { CardCode } = this.selectedUnit;
        cardCode = CardCode;
      }

      await this.TenantDataService.registerTenant(this.tenant, cardCode);

      if (isUpdating) {
        this.NotificationService.success('TENANT UPDATED');
      } else {
        this.NotificationService.success('TENANT REGISTERED');
      }

      await this.getTenantByCardCode();
    } catch (error) {
      console.error(error);
    } finally {
      this.$timeout(() => {
        this.tenant = null;
        this.noTenantForUnit = !!!this.TenantDataService.tenant;
        this.isTenantLoading = false;
      });
    }
  }

  async deregisterTenant() {
    try {
      this.isTenantLoading = true;
      await this.tenantService.deregisterTenant(this.tenantService.tenant.Id);
      this.NotificationService.success('TENANT DE-REGISTERED');
      await this.getTenantByCardCode();
    } catch (error) {
      console.error(error);
    } finally {
      this.$timeout(() => {
        this.tenant = null;
        this.noTenantForUnit = !!!this.TenantDataService.tenant;
        this.isTenantLoading = false;
      });
    }
  }

  updateTenantDetails() {
    this.isEditingTenant = true;
    const { tenant } = this.TenantDataService;
    this.tenant = tenant;
  }

  _handleEvents() {
    this.$scope.$watch(
      'TenantVM.selectedUnit',
      newValue => {
        if (!!newValue) {
          const userUnit =
            typeof newValue === 'string'
              ? newValue.includes('{')
                ? JSON.parse(newValue)
                : newValue
              : { CardCode: null };
          const { CardCode: cardCode } = userUnit;
          this.handleUnitChange(cardCode);
        }
      },
      true
    );

    this.$scope.$on('selected-building-changed', async (event, newValue) => {
      const hasAccess = this.AuthorizationService.isAuthorized(
        USER_CLAIMS.REGISTER_TENANT
      );
      if (!hasAccess) {
        this.$state.go(FEATURES.PAYMENTS);
      } else {
        await this.initialiseScreen();
        this.$timeout(() => {
          this.userUnits = this.getUserUnits();
        });
        this.$parent.loadTilesData();
      }

      //this.$scope.$emit('selected-building-changed', newValue);
    });

    this.$scope.$watch('TenantVM.isTenantLoading', (newValue, oldValue) => {
      if (newValue) {
        this._initializeDatePicker();
      }
    });
  }

  _initializeDatePicker() {
    const leaseEndDate = moment(this.dateTo).format('YYYY/MM/DD');
    const leaseStartDate = moment(this.dateFrom).format('YYYY/MM/DD');

    this.$rootScope.$eval(() => {
      this.$timeout(() => {
        const id = 'form[name="registerTenant"]';
        const selectorDateFrom = '#leaseStartDatePicker';
        const selectorDateTo = '#leaseEndDatePicker';

        const $inputDateFrom = angular.element(
          selectorDateFrom,
          angular.element(id)
        );
        const $inputDateTo = angular.element(
          selectorDateTo,
          angular.element(id)
        );

        const optionsDateFrom = {
          leaseStartDate,
          autoclose: true,
          forceParse: true,
          format: 'yyyy/mm/dd',
          assumeNearbyYear: true,
          enableOnReadonly: true,
          container: selectorDateFrom
        };

        const optionsDateTo = {
          leaseEndDate,
          autoclose: true,
          forceParse: true,
          format: 'yyyy/mm/dd',
          assumeNearbyYear: true,
          enableOnReadonly: true,
          container: selectorDateTo
        };

        $inputDateFrom.datepicker(optionsDateFrom);
        $inputDateTo.datepicker(optionsDateTo);
      }, 250);
    });
  }
}
